import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Holiday(): React.ReactElement {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#holiday)">
        <path d="M4.62294 7.72557L4.43883 8.81911C4.41374 8.96861 4.47508 9.11927 4.59747 9.20849C4.72005 9.29752 4.88282 9.30944 5.01675 9.23926L5.99991 8.72604L6.98308 9.23935C7.04125 9.26954 7.10499 9.28473 7.16806 9.28473C7.25065 9.28473 7.33304 9.25887 7.40256 9.20859C7.52504 9.11937 7.58658 8.96871 7.56129 8.81921L7.37737 7.72567L8.16901 6.94911C8.27727 6.84307 8.31583 6.68481 8.26939 6.54079C8.22276 6.39686 8.09796 6.29149 7.94817 6.26938L6.85117 6.1067L6.35709 5.11363C6.29008 4.97807 6.15125 4.89221 5.99982 4.89221C5.84868 4.89221 5.70995 4.97807 5.64236 5.11363L5.14875 6.1067L4.05175 6.26928C3.90167 6.29139 3.77746 6.39677 3.73073 6.54069C3.684 6.68472 3.72246 6.84316 3.83091 6.94902L4.62294 7.72557Z" fill="white"/>
        <path d="M10.7146 1.27573H9.4585V0.578978C9.4585 0.259204 9.1993 0 8.87943 0H8.78761C8.46783 0 8.20873 0.259204 8.20873 0.578978V1.27573H3.77678V0.578978C3.77678 0.259204 3.51758 0 3.1979 0H3.10599C2.78621 0 2.52711 0.259204 2.52711 0.578978V1.27573H1.2856C0.62865 1.27573 0.0939941 1.8102 0.0939941 2.46734V10.8085C0.0939941 11.4652 0.62865 12.0001 1.2856 12.0001H10.7147C11.3716 12.0001 11.9063 11.4653 11.9063 10.8085V2.46734C11.9062 1.8102 11.3715 1.27573 10.7146 1.27573ZM10.5592 10.653H1.44107V4.15995H10.5592V10.653Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="holiday">
          <rect width="12" height="12" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
